//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import setting from "@/components/management/QAHelper/setting";
import statistics from "@/components/management/QAHelper/statistics";
export default {
  name: "QAHelper",
  data: function data() {
    return {
      loading: false,
      activeTabName: "statistics",
      componentList: [{
        is: "statistics",
        label: "统计"
      }, {
        is: "setting",
        label: "问题设置"
      }]
    };
  },
  components: {
    setting: setting,
    statistics: statistics
  },
  computed: {},
  watch: {},
  created: function created() {},
  methods: {}
};